import {InfoCircleFilled} from "@ant-design/icons";
import {Tooltip} from "antd";
import VulSourceItem from "../../domain/VulSourceItem";
import {formatAiAttributeSummaryValue} from "./AiAttributeSummaryUtils";
import {AiAttributeRatingMultiChip, AiExtractorEntryList} from "../common/AiAttributeRating";
import SummaryBlock, {SummaryBlockList} from "../common/SummaryBlock";
import {getRatingAiAttributeEntries, getSummaryAiAttributeEntries, getTextAiAttributeEntries} from "./AiAttributeEntries";
import AiAttributeTextTag from "./AiAttributeTextTag";
import * as styles from "./AiAttributeEntriesBlock.module.css";

interface Props {
    item: VulSourceItem | undefined;
    aiAttributeTagClassName: string;
    aiAttributeTagInteractiveClassName: string;
}

function AiAttributeEntriesBlock(props: Props) {
    const summaryAiAttributeEntries = getSummaryAiAttributeEntries(props.item);
    const ratingAiAttributeEntries = getRatingAiAttributeEntries(props.item);
    const textAiAttributeEntries = getTextAiAttributeEntries(props.item);

    if (summaryAiAttributeEntries.length === 0 && ratingAiAttributeEntries.length === 0 && textAiAttributeEntries.length === 0) {
        return null;
    }

    return (
        <div className={styles["ai-box"]}>
            <div className={styles["ai-header"]}>
                <span>AI analytics</span>
            </div>
            <div className={styles["ai-content"]}>
                {summaryAiAttributeEntries.length > 0 && (
                    <SummaryBlockList>
                        {summaryAiAttributeEntries.map(([key, aiAttributeValue]) => (
                            <SummaryBlock
                                key={key}
                                className={styles["summary-soft"]}
                                label={<>
                                    {key}
                                    {" "}
                                    <Tooltip title={<AiExtractorEntryList entries={aiAttributeValue.values ?? []}/>} overlayStyle={{maxWidth: "none"}}>
                                        <InfoCircleFilled style={{color: "#8c8c8c"}}/>
                                    </Tooltip>
                                </>}
                            >
                                {formatAiAttributeSummaryValue(aiAttributeValue)}
                            </SummaryBlock>
                        ))}
                    </SummaryBlockList>
                )}

                {(ratingAiAttributeEntries.length > 0 || textAiAttributeEntries.length > 0) && (
                    <div className={styles["inline-entries"]}>
                        {ratingAiAttributeEntries.map(([key, aiAttributeValue]) => (
                            <AiAttributeRatingMultiChip key={`r-${key}`} label={key} values={aiAttributeValue.values ?? []}/>
                        ))}
                        {textAiAttributeEntries.map(([key, aiAttributeValue]) => (
                            <AiAttributeTextTag
                                key={`t-${key}`}
                                label={key}
                                aiAttributeValue={aiAttributeValue}
                                aiAttributeTagClassName={props.aiAttributeTagClassName}
                                aiAttributeTagInteractiveClassName={props.aiAttributeTagInteractiveClassName}
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default AiAttributeEntriesBlock;
